var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 14C11 12.8954 11.8954 12 13 12H24C25.1046 12 26 12.8954 26 14V16H13C11.8954 16 11 15.1046 11 14V14Z", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M11 14V26C11 27.1046 11.8954 28 13 28H27C28.1046 28 29 27.1046 29 26V18C29 16.8954 28.1046 16 27 16H24", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M29 19.5H25.25C24.0074 19.5 23 20.5074 23 21.75V21.75C23 22.9926 24.0074 24 25.25 24H29", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" })
  );
});